import * as React from "react";
import { ChangeHandler, DiffChangeHandler, MonacoDiffEditorProps } from "react-monaco-editor";
import ResizeableMonacoEditor from "./ResizeableMonacoEditor";
import { Button, Icon, Tabs, Tooltip } from "antd";
import styles from './Banners.module.less'
import { IBannerVariables } from "../../store/banner/variables/types";
import { monacoTheme } from "../../constants/monaco";
import FileSystemContainer from "../../containers/FileSystemContainer";
import HtmlTemplateContainer from "../../containers/HtmlTemplateContainer";
import FeedContainer from "../../containers/FeedContainer";

const { TabPane } = Tabs;

interface TemplatesProps {
    templateEditorProps: ITemplateEditorProps;
    customCode: string;
    codeEditorLayout?: number;
    output: string;
    onCustomCodeChange?: ChangeHandler;
    preview?: () => void;
    onActiveBannerVariablesChange?: (activeBannerVariables: Partial<IBannerVariables>) => void
}

export interface ITemplateEditorProps {
    value: string;
    original?: string;
    diffMode?: boolean;
    size?: number;
    active?: string;
    onChange: ChangeHandler;
    onDiffChange: DiffChangeHandler;
    diffEditorProps?: MonacoDiffEditorProps
}

interface IState {
    activeKey: string
}

class Templates extends React.Component<TemplatesProps, IState> {
    state = {
        activeKey: "1"
    };

    render() {
        // console.log("Templates render........")
        let templateEditorProps = {
            ...this.props.templateEditorProps,
            active: this.state.activeKey,
            language: "html",
            theme: monacoTheme,
            editMode: false,
        }
        let previewButton = <Tooltip title="Rebuild Banner">
            <Icon type="redo" onClick={this.props.preview} />
        </Tooltip>
        return (
            <Tabs
                animated={false}
                defaultActiveKey="folders"
                size="small"
                onChange={(activeKey: string) => this.setState({ activeKey: activeKey })}
                tabBarExtraContent={<span>{previewButton}</span>}
            >
                <TabPane tab="Folders" key="folders" className={styles.templateTab}>
                    <FileSystemContainer />
                </TabPane>
                <TabPane tab="Files" key="files" className={styles.templateTab}>
                    <HtmlTemplateContainer />
                </TabPane>
                <TabPane tab="Template" key="template" className={styles.templateTab}>
                    <ResizeableMonacoEditor {...templateEditorProps} />
                </TabPane>
                <TabPane tab="Custom Code" key="customCode" className={styles.templateTab}>
                    <ResizeableMonacoEditor
                        value={this.props.customCode}
                        language={"rlang"}
                        theme={monacoTheme}
                        onChange={this.props.onCustomCodeChange}
                        size={this.props.codeEditorLayout}
                        active={this.state.activeKey}
                    />
                </TabPane>
                <TabPane tab="Sample Feed" key="sampleFeed" className={styles.templateTab}>
                    <FeedContainer />
                </TabPane>
                <TabPane tab="Html" key="html" className={styles.templateTab}>
                    <ResizeableMonacoEditor
                        options={{ readOnly: true }}
                        value={this.props.output}
                        language={"html"}
                        theme={monacoTheme}
                        size={this.props.codeEditorLayout}
                        active={this.state.activeKey}
                    />
                </TabPane>
            </Tabs>
        )
    }
}

export default Templates;

